import dictionariesApi from '@/api/dictionariesApi'

const state = () => ({
  usersList: [],
  roleList: [],
  statusList: [],
  departmentList: [],
  positionList: [],
  employmentList: [],
  scheduleList: [],
  kinshipList: [],
  documentTypesList: [],
  educationTypesList: [],
  educationSpecialityList: [],
  educationDocumentList: [],
  tasksList: [],
  tasksColumnList: [],
  taskNotificationTypes: []
})

const getters = {
  '[dictionaries] usersList': state => state.usersList,
  '[dictionaries] usersRoleList': state => state.roleList,
  '[dictionaries] usersStatusList': state => state.statusList,
  '[dictionaries] usersDepartmentList': state => state.departmentList,
  '[dictionaries] usersPositionList': state => state.positionList,
  '[dictionaries] usersEmploymentList': state => state.employmentList,
  '[dictionaries] usersScheduleList': state => state.scheduleList,
  '[dictionaries] usersKinshipList': state => state.kinshipList,
  '[dictionaries] usersDocumentTypesList': state => state.documentTypesList,
  '[dictionaries] usersEducationTypesList': state => state.educationTypesList,
  '[dictionaries] usersEducationSpecialityList': state => state.educationSpecialityList,
  '[dictionaries] usersEducationDocumentList': state => state.educationDocumentList,
  '[dictionaries] tasksList': state => state.tasksList,
  '[dictionaries] tasksColumnList': state => state.tasksColumnList,
  '[dictionaries] taskNotificationTypes': state => state.taskNotificationTypes,

  // геттеры свойств по ID
  getUserById: state => id => {
    return state.usersList.find(user => user.id === id)?.name || ''
  },
  getFullUserById: state => id => {
    return state.usersList.find(user => user.id === id)
  },
  getStatusById: state => id => {
    return id ? state.statusList.find(status => status.id === id)?.name : 'Не определен'
  },
  getDepartmentById: state => id => {
    return id ? state.departmentList.find(department => department.id === id)?.name : 'Не определен'
  },
  getPositionById: state => id => {
    return id ? state.positionList.find(position => position.id === id)?.name : 'Не указана'
  },
  getEmploymentById: state => id => {
    return id ? state.employmentList.find(employment => employment.id === id)?.name : 'Не указан'
  },
  getColumnById: state => id => {
    // колонка === статус, поэтому "Не определен"
    return id ? state.tasksColumnList.find(column => column.id === id)?.name : 'Не определен'
  },
  getTaskNotificationTypeByValue: state => value => {
    return state.taskNotificationTypes.find(type => type.value === value)?.description
  }
}

const mutations = {
  '[dictionaries] SET_USERS': (state, usersList) => {
    const users = []
    usersList.forEach((user) => {
      users.push({
        id: user.id,
        name: `${user.profile?.surname ? user.profile.surname : ''} ${user.profile?.name ? user.profile.name : ''} ${user.profile?.patronymic ? user.profile.patronymic : ''}`,
        avatar: user.avatar ? user.avatar : null,
        position: user.position ? user.position : null
      })
    })
    state.usersList = users
  },
  '[dictionaries] SET_USERS_ROLE_LIST': (state, roleList) => {
    state.roleList = roleList
  },
  '[dictionaries] SET_USERS_STATUS_LIST': (state, statusList) => {
    state.statusList = statusList
  },
  '[dictionaries] SET_USERS_DEPARTMENT_LIST': (state, departmentList) => {
    state.departmentList = departmentList
  },
  '[dictionaries] SET_USERS_POSITION_LIST': (state, positionList) => {
    state.positionList = positionList
  },
  '[dictionaries] SET_USERS_EMPLOYMENT_LIST': (state, employmentList) => {
    state.employmentList = employmentList
  },
  '[dictionaries] SET_USERS_SCHEDULE_LIST': (state, scheduleList) => {
    state.scheduleList = scheduleList
  },
  '[dictionaries] SET_USERS_KINSHIP_LIST': (state, kinshipList) => {
    state.kinshipList = kinshipList
  },
  '[dictionaries] SET_USERS_DOCUMENTS_TYPES_LIST': (state, documentTypesList) => {
    state.documentTypesList = documentTypesList
  },
  '[dictionaries] SET_USERS_EDUCATION_TYPES_LIST': (state, typesList) => {
    state.educationTypesList = typesList
  },
  '[dictionaries] SET_USERS_EDUCATION_SPECIALITY_LIST': (state, specialityList) => {
    state.educationSpecialityList = specialityList
  },
  '[dictionaries] SET_USERS_EDUCATION_DOCUMENT_LIST': (state, documentList) => {
    state.educationDocumentList = documentList
  },
  '[dictionaries] SET_TASKS_LIST': (state, tasksList) => {
    /* в список должны попадать только активные задачи, колонка id 3 - Завершенные */
    state.tasksList = tasksList.filter(task => {
      return task.column_id !== 3
    }).map(task => {
      return { id: task.id, name: task.name }
    })
  },
  '[dictionaries] SET_TASKS_COLUMN_LIST': (state, columnList) => {
    state.tasksColumnList = columnList.map(column => {
      return { id: column.id, name: column.name, color: column.color }
    })
  },
  '[dictionaries] SET_TASKS_NOTIFICATIONS_TYPES': (state, notificationTypes) => {
    state.taskNotificationTypes = notificationTypes
  }
}

const actions = {
  '[dictionaries] getUserList' ({ commit }, payload) {
    const params = {
      pagination: {
        currentPage: payload?.pagination && payload.pagination.currentPage ? payload.pagination.currentPage : 1,
        perPage: payload?.pagination && payload.pagination.perPage ? payload.pagination.perPage : 99999
      },
      filter: {
        search: payload?.filter && payload.filter.search ? payload.filter.search : ''
      }
    }
    dictionariesApi.getUserOptionList(params).then(response => {
      commit('[dictionaries] SET_USERS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка пользователей (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getRoleList' ({ commit }) {
    dictionariesApi.getRoleList().then(response => {
      commit('[dictionaries] SET_USERS_ROLE_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка ролей пользователей (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getStatusList' ({ commit }) {
    dictionariesApi.getStatusList().then(response => {
      commit('[dictionaries] SET_USERS_STATUS_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка статусов пользователей (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getDepartmentList' ({ commit }) {
    dictionariesApi.getDepartmentList().then(response => {
      commit('[dictionaries] SET_USERS_DEPARTMENT_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка отделов (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getPositionList' ({ commit }) {
    dictionariesApi.getPositionList().then(response => {
      commit('[dictionaries] SET_USERS_POSITION_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка должностей (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getEmploymentList' ({ commit }) {
    dictionariesApi.getEmploymentList().then(response => {
      commit('[dictionaries] SET_USERS_EMPLOYMENT_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка видов занятости (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getScheduleList' ({ commit }) {
    dictionariesApi.getScheduleList().then(response => {
      commit('[dictionaries] SET_USERS_SCHEDULE_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка графиков (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getKinshipList' ({ commit }) {
    dictionariesApi.getKinshipList().then(response => {
      commit('[dictionaries] SET_USERS_KINSHIP_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка степеней родства (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getDocumentTypes' ({ commit }) {
    dictionariesApi.getDocumentTypes().then(response => {
      commit('[dictionaries] SET_USERS_DOCUMENTS_TYPES_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка видов документов (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getEducationTypes' ({ commit }) {
    dictionariesApi.getEducationTypes().then(response => {
      commit('[dictionaries] SET_USERS_EDUCATION_TYPES_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка видов (образование) (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getSpecialities' ({ commit }) {
    dictionariesApi.getSpecialities().then(response => {
      commit('[dictionaries] SET_USERS_EDUCATION_SPECIALITY_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка специальностей (образование) (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getEducationDocumentList' ({ commit }) {
    dictionariesApi.getEducationDocumentList().then(response => {
      commit('[dictionaries] SET_USERS_EDUCATION_DOCUMENT_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка видов документов (образование) (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getTaskOptionList' ({ commit }) {
    dictionariesApi.getTaskOptionList().then(response => {
      commit('[dictionaries] SET_TASKS_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка задач (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getTaskColumns' ({ commit }) {
    dictionariesApi.getTaskColumns().then(response => {
      commit('[dictionaries] SET_TASKS_COLUMN_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка колонок задач (при загрузке приложения)', error)
    })
  },
  '[dictionaries] getTaskProcessTypes' ({ commit }) {
    dictionariesApi.getTaskProcessTypes().then(response => {
      commit('[dictionaries] SET_TASKS_NOTIFICATIONS_TYPES', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка типов уведомлений по задачам (при загрузке приложения)', error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
